import React from 'react';

import { FormattedMessage } from 'react-intl';

import Avatar from '@atlaskit/avatar/avatar';

import { messages } from '../../../../../messages';
import { useAIAnswerContext } from '../../../../ai-answer-context';
import { onWhoAdditionalMatchProfileClick } from '../../../../on-who-additional-match-profile-click';
import { onWhoAdditionalMatchProfileContextMenuClick } from '../../../../on-who-additional-match-profile-context-menu-click';
import type { NLPSearchWhoResultType } from '../../../../types';
import { getTypedJSONResultDataAssistanceService } from '../../../../utils/getTypedJSONResultData';

import { AIWhoAnswerFooter } from './ai-who-answer-footer';
import { AIWhoAnswerFooterHeader } from './ai-who-answer-footer-header';
import { AIWhoAnswerFooterResult } from './ai-who-answer-footer-result';
import { AIWhoAnswerFooterResultInfoHeader } from './ai-who-answer-footer-result-info-header';
import { AIWhoAnswerFooterResultInfoWrapper } from './ai-who-answer-footer-result-info-wrapper';
import { AIWhoAnswerFooterResultMetadata } from './ai-who-answer-footer-result-metadata';
import { AIWhoAnswerFooterResultsWrapper } from './ai-who-answer-footer-results-wrapper';

export const AIAnswerWhoFooter = (): React.JSX.Element | null => {
	const { commonAttributes, fireAnalyticsEvent, onNavigate } = useAIAnswerContext();
	const { answerString } = commonAttributes;

	// answerString should have at least one result or else <AIAnswerError /> will be rendered
	const { parsedResult } = getTypedJSONResultDataAssistanceService(answerString);

	const additionalUserResults = (parsedResult as NLPSearchWhoResultType['user_metadata']).slice(1);
	const numAdditionalUserResults = additionalUserResults.length;

	return numAdditionalUserResults ? (
		<AIWhoAnswerFooter>
			<AIWhoAnswerFooterHeader>
				<FormattedMessage
					{...messages.ai_answer_who_questions_footer_header}
					values={{ numMatches: numAdditionalUserResults }}
				/>
			</AIWhoAnswerFooterHeader>
			<AIWhoAnswerFooterResultsWrapper>
				{additionalUserResults.map((userResult: any) => (
					<AIWhoAnswerFooterResult
						key={userResult.name}
						href={userResult.profile_url || undefined}
						onClick={(event) => {
							onNavigate(event);
							fireAnalyticsEvent(
								onWhoAdditionalMatchProfileClick({
									...commonAttributes,
									additionalMatchUserName: userResult.name,
									additionalMatchTitle: userResult.job_title || '',
								}),
							);
						}}
						onContextMenu={(event) => {
							onNavigate(event);
							fireAnalyticsEvent(
								onWhoAdditionalMatchProfileContextMenuClick({
									...commonAttributes,
									additionalMatchUserName: userResult.name,
									additionalMatchTitle: userResult.job_title || '',
								}),
							);
						}}
					>
						<Avatar
							src={userResult.avatar_url || undefined}
							size="medium"
							testId={userResult.name}
						/>
						<AIWhoAnswerFooterResultInfoWrapper>
							<AIWhoAnswerFooterResultInfoHeader>
								{userResult.name}
							</AIWhoAnswerFooterResultInfoHeader>
							<AIWhoAnswerFooterResultMetadata>
								{userResult.job_title}
							</AIWhoAnswerFooterResultMetadata>
						</AIWhoAnswerFooterResultInfoWrapper>
					</AIWhoAnswerFooterResult>
				))}
			</AIWhoAnswerFooterResultsWrapper>
		</AIWhoAnswerFooter>
	) : null;
};
